import { useQuery } from '@tanstack/react-query'
import { getRlcpStructure } from '../api/data-connectors/rlcp-files'
import { isRlcpNotFoundError } from '../utils'

export function useGetRlcpFiles(reportNumber: string, enabled: boolean = true) {
  return useQuery({
    queryKey: ['rlcp-structure', reportNumber],
    queryFn: () => getRlcpStructure(reportNumber),
    enabled: enabled && !!reportNumber,
    staleTime: 3 * 60 * 1000, // 3 minutes
    retry: (failureCount, error) => !isRlcpNotFoundError(error) && failureCount < 1,
  })
}
